import { callApi } from "Apis";
import { BANNERURL } from "helpers/constant";

export async function bannerList(data) {
  try {
    const response = await callApi({ url: BANNERURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function bannerAdd(data) {
  try {
    const response = await callApi({ url: BANNERURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getBannerById(id) {
  try {
    const response = await callApi({ url: BANNERURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateBanner(data) {
  try {
    const response = await callApi({ url: BANNERURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteBannerById(id) {
  try {
    const response = await callApi({ url: BANNERURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
